import { DIST_EPSILON_32BIT } from "geom/core";
import type { Mesh3 } from "geom/mesh";
import { weldMeshByQuantizedPosition } from "geom/welding";
import { MeshoptSimplifier } from "meshoptimizer";

const TARGET_INDEX_COUNT = 30;
const TARGET_ERROR = 0.5;

export async function simplifyMesh3WithMeshoptimizer(mesh: Mesh3): Promise<Mesh3> {
  if (mesh.tris.length <= TARGET_INDEX_COUNT) {
    return mesh;
  }
  await MeshoptSimplifier.ready;
  weldMeshByQuantizedPosition(mesh, DIST_EPSILON_32BIT);
  const simplifiedIndices = MeshoptSimplifier.simplify(mesh.tris, mesh.verts, 3, TARGET_INDEX_COUNT, TARGET_ERROR, [
    "Prune",
  ]);
  return { ...mesh, tris: simplifiedIndices[0] };
}

interface HasMesh {
  mesh: Mesh3;
}

const enableTiming = false;

export async function simplifyMesh<T extends HasMesh>(hasMesh: T): Promise<T> {
  if (enableTiming) {
    console.time("simplifyMesh");
  }
  const simplifiedMesh = await simplifyMesh3WithMeshoptimizer(hasMesh.mesh);
  // console.log("mesh optimized from", hasMesh.mesh.tris.length, "to", simplifiedMesh.tris.length);
  if (enableTiming) {
    console.timeEnd("simplifyMesh");
  }
  return { ...hasMesh, mesh: simplifiedMesh };
}
